(function(){

function loyInit(){
document.querySelectorAll('.loy-pdp').forEach(function(sec){
  if(sec.dataset.loyReady) return;
  sec.dataset.loyReady = '1';

  var root = sec;
  var data = root.querySelector('[data-variants]');
  var variants = [];
  try { variants = JSON.parse(data.textContent); } catch(e){ return; }

  var vid   = root.querySelector('[data-vid]');
  var price = root.querySelector('[data-price]');
  var comp  = root.querySelector('[data-compare]');
  var unit  = root.querySelector('[data-unit]');
  var ship  = root.querySelector('[data-ship]');
  var cta   = root.querySelector('[data-cta]');
  var ctaT  = root.querySelector('[data-cta-text]');
  var base  = parseInt(root.dataset.base || '0', 10);

  var payRow = root.querySelector('.loy-pay');
  if(payRow){
    var allow = ['klarna','mastercard','visa','american express','apple pay','google pay','paypal'];
    payRow.querySelectorAll('svg').forEach(function(svg){
      var t = svg.querySelector('title');
      var n = t ? t.textContent.toLowerCase().trim() : '';
      if(allow.indexOf(n) === -1){ svg.style.display = 'none'; }
      else { svg.style.height = '24px'; }
    });
    if(!payRow.querySelector('.loy-wero')){
      var w = document.createElement('span');
      w.className = 'loy-wero';
      w.textContent = 'wero';
      w.setAttribute('aria-label','Wero');
      w.style.cssText = 'display:flex;align-items:center;justify-content:center;width:66px;height:24px;background:#F5E86F;color:#1E1E1E;font-family:Inter,Arial,sans-serif;font-weight:800;font-size:13px;letter-spacing:-.3px;border-radius:3px;flex:0 0 auto;';
      payRow.insertBefore(w, payRow.firstChild);
    }
  }

  function money(c){
    return '€' + (c/100).toFixed(2).replace('.', ',');
  }
  function chosen(){
    var out = [];
    root.querySelectorAll('input[type=radio]:checked').forEach(function(r){
      out[parseInt(r.dataset.idx,10)] = r.value;
    });
    return out;
  }
  /* Bewust zonder backslash-klassen geschreven: dit bestand gaat via de API
     naar het thema en backslashes overleven die route niet betrouwbaar. */
  function parseQty(title){
    var m = String(title).match(/([0-9]+)[ ]*(stuks?|fles(?:sen)?|takjes?)/i);
    if(!m) return {n:0, word:''};
    var w = m[2].toLowerCase();
    return {n: parseInt(m[1],10), word: w.indexOf('fles') === 0 ? 'per fles' : 'per stuk'};
  }

  /* Zoekt de variant die bij één trede hoort, met de overige opties op hun
     huidige keuze. Daardoor kloppen de prijzen per trede ook bij producten
     met twee opties, zoals Kwaliteit x Aantal. */
  function tierVariant(idx, value){
    var sel = chosen();
    sel[idx] = value;
    return variants.find(function(v){
      return v.options.every(function(o,i){ return sel[i] === undefined || o === sel[i]; });
    });
  }

  /* Een optiekaart (Kwaliteit: Basis / Premium) die in geen enkele variant
     meer leverbaar is, tonen we meteen als uitverkocht. Anders kiest iemand
     Premium en merkt hij het pas bij de knop. */
  function optieVrij(idx, waarde){
    return variants.some(function(v){
      return v.options[idx] === waarde && v.available !== false;
    });
  }

  function paintCards(){
    root.querySelectorAll('.loy-card').forEach(function(c){
      var inp = c.querySelector('input[type=radio]');
      if(!inp) return;
      var idx = parseInt(inp.dataset.idx, 10);
      var ok  = optieVrij(idx, inp.value);
      c.classList.toggle('is-uit', !ok);
      inp.disabled = !ok;
      var box  = c.querySelector('.loy-card__box');
      var flag = c.querySelector('.loy-card__flag');
      if(!ok){
        if(!flag && box){
          flag = document.createElement('span');
          flag.className = 'loy-card__flag';
          box.insertBefore(flag, box.firstChild);
        }
        if(flag){
          if(typeof flag.dataset.loyVlag === 'undefined'){ flag.dataset.loyVlag = flag.textContent; }
          flag.textContent = 'Tijdelijk uitverkocht';
        }
        if(inp.checked){
          var alt = null;
          root.querySelectorAll('.loy-cards input[type=radio]').forEach(function(o){
            if(alt || o === inp) return;
            if(o.dataset.idx !== inp.dataset.idx) return;
            if(optieVrij(parseInt(o.dataset.idx,10), o.value)) alt = o;
          });
          if(alt){ alt.checked = true; }
        }
      } else if(flag && typeof flag.dataset.loyVlag !== 'undefined'){
        flag.textContent = flag.dataset.loyVlag;
      }
    });
  }

  /* De abonnementsladder zet er nog het oude aantal sticks onder, omdat dat
     in main-product.liquid hardgecodeerd staat. We halen het aantal daarom
     uit de naam van de trede zelf, zodat regel en prijs per stick altijd
     bij de titel passen. */
  function paintAbo(){
    root.querySelectorAll('.loy-tier--link').forEach(function(t){
      var nEl = t.querySelector('.loy-tier__n');
      var uEl = t.querySelector('.loy-tier__u');
      var pEl = t.querySelector('.loy-tier__p');
      var sEl = t.querySelector('.loy-tier__s');
      if(!nEl || !uEl) return;
      var m = String(nEl.textContent).match(/([0-9]+)[ ]*(?:[A-Za-zé]+[ ]*)?[Nn]avullingen/);
      if(!m) return;
      var n = parseInt(m[1], 10);
      if(!n) return;
      uEl.textContent = n + ' navullingen per levering';
      if(pEl && sEl){
        var c = parseInt(String(pEl.textContent).replace(/[^0-9]/g, ''), 10);
        if(c){ sEl.textContent = money(Math.round(c / n)) + ' per stick'; }
      }
    });
  }

  if(!document.getElementById('loy-uit-stijl')){
    var st = document.createElement('style');
    st.id = 'loy-uit-stijl';
    st.textContent = '.loy-pdp .loy-card.is-uit{cursor:not-allowed}.loy-pdp .loy-card.is-uit .loy-card__box{opacity:.42}.loy-pdp .loy-card.is-uit .loy-card__flag{background:#8C8578;color:#fff}';
    document.head.appendChild(st);
  }

  function paintTiers(){
    root.querySelectorAll('.loy-tier').forEach(function(t){
      var inp = t.querySelector('input[type=radio]');
      if(!inp) return;
      var v  = tierVariant(parseInt(inp.dataset.idx,10), inp.value);
      var q  = parseQty(inp.value);
      var pEl = t.querySelector('[data-tier-price]');
      var uEl = t.querySelector('[data-tier-unit]');
      var sEl = t.querySelector('[data-tier-save]');
      if(!v){
        if(pEl) pEl.textContent = '';
        if(uEl) uEl.textContent = '';
        if(sEl) sEl.textContent = '';
        t.classList.add('is-uit');
        return;
      }
      t.classList.toggle('is-uit', v.available === false);
      if(pEl) pEl.textContent = money(v.price);
      if(uEl) uEl.textContent = q.n > 1 ? money(Math.round(v.price / q.n)) + ' ' + q.word : '';
      if(sEl){
        var txt = '';
        if(v.compare_at_price && v.compare_at_price > v.price){
          txt = money(v.compare_at_price - v.price) + ' voordeel';
        } else if(base > 0 && q.n > 1){
          /* Alleen wanneer er een echte losse eenheid bestaat om mee te
             vergelijken. Bestaat die niet, dan geen bedacht besparingsbedrag. */
          var s = (base * q.n) - v.price;
          if(s > 0) txt = 'bespaar ' + money(s);
        }
        if(v.available === false) txt = 'uitverkocht';
        sEl.textContent = txt;
      }
    });
  }

  function paint(v){
    if(!v) return;
    if(vid) vid.value = v.id;
    if(price) price.textContent = money(v.price);
    if(comp){
      if(v.compare_at_price && v.compare_at_price > v.price){
        comp.textContent = money(v.compare_at_price); comp.hidden = false;
      } else { comp.hidden = true; }
    }
    if(unit){
      var q = parseQty(v.title);
      var txt = '';
      if(q.n > 1){
        txt = money(Math.round(v.price/q.n)) + ' ' + q.word;
        if(base > 0){
          var save = (base * q.n) - v.price;
          if(save > 0) txt += ' · je bespaart ' + money(save);
        }
      }
      unit.textContent = txt;
    }
    if(ship){
      ship.textContent = v.price >= 3000 ? 'Gratis verzending inbegrepen' : '';
    }
    if(cta){
      cta.disabled = !v.available;
      if(ctaT) ctaT.textContent = v.available ? 'In winkelmand' : 'Uitverkocht';
    }
    if(v.featured_image && v.featured_image.src){
      var main = root.querySelector('[data-main]');
      if(main) main.src = v.featured_image.src;
    }
    if(history.replaceState){
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u);
    }
  }
  function match(){
    var sel = chosen();
    return variants.find(function(v){
      return v.options.every(function(o,i){ return sel[i] === undefined || o === sel[i]; });
    });
  }
  root.querySelectorAll('input[type=radio]').forEach(function(r){
    r.addEventListener('change', function(){ paintCards(); paintTiers(); paint(match()); });
  });
  paintCards();
  paintAbo();
  paintTiers();
  paint(match());

  root.querySelectorAll('.loy-pdp__thumb').forEach(function(t){
    t.addEventListener('click', function(){
      var main = root.querySelector('[data-main]');
      if(main && t.dataset.full) main.src = t.dataset.full;
      root.querySelectorAll('.loy-pdp__thumb').forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var tabs = root.querySelectorAll('.loy-tabs__t');
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      var i = t.dataset.tab;
      tabs.forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-selected','false'); });
      t.classList.add('is-on'); t.setAttribute('aria-selected','true');
      root.querySelectorAll('.loy-tabs__p').forEach(function(p){
        p.classList.toggle('is-on', p.dataset.panel === i);
      });
    });
  });
});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loyInit);
} else {
  loyInit();
}
document.addEventListener('shopify:section:load', loyInit);

})();